import { mockBasket } from '@domgen/dgx-fe-basket';
import { CheckoutResponse } from '../../models/checkout/checkout-response.interface';

export const mockCheckoutResponse: CheckoutResponse = {
  completedItems: [],
  basket: mockBasket,
};
